export default __webpack_public_path__ + "static/feedback@1x-4240a5afcb513f71ef049d339daf68e5.jpg";